import { memo } from 'react'

import { Text } from '@cash-me/react-components'

import { Help } from 'modules/help-v2'

import { condominiumCreditAccordion } from './data'

type Props = {
  onClick: () => void
}

export const CondominiumCreditHelp = memo(({ onClick }: Props) => (
  <Help
    accordion={condominiumCreditAccordion}
    $bg="medium"
    $previousBG="neutral-background-default"
    buttonAriaLabel="Solicitar uma simulação de crédito para condomínio"
    buttonLabel="Solicitar uma simulação"
    layoutVariant="long-form"
    longFormMinHeight="800px"
    onClick={onClick}
    showButtonArrow={false}
  >
    <Text as="h2" size="heading2" weight="medium" color="var(--colors-neutral-text-contrast-default)">
      <Text as="span" size="heading2" weight="medium" color="var(--colors-cyan-background-pressed)">
        Tire as suas dúvidas{' '}
      </Text>
      sobre Crédito para Condomínios
    </Text>
  </Help>
))

CondominiumCreditHelp.displayName = 'CondominiumCreditHelp'
